const state = {
  pageConfig: []
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js